import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'

import './formlabel.scss'

/* @TODO
 * - proptypes
 */

const FormLabel = (props) => {
	const { children, className, disabled = false, component, variant = 'label' } = props

	const Component = component || variant === 'legend' ? 'legend' : 'label'

	return (
		<Component
			className={clsx(
				'Vb-formlabel',
				disabled && 'Vb-formlabel__disabled',
				variant === 'legend' ? 'Vb-formlabel__legend' : null,
				className
			)}
			{...props}
		>
			{children}
		</Component>
	)
}

export default FormLabel
